import React from 'react';

import { Divider, Header } from '@rbilabs/universal-components';
import * as Updates from 'expo-updates';
import { getBuildMetadata } from 'modules/bk-build-metadata';

import { appVersion, binaryRuntimeAppVersionWithBuildNumber } from 'utils/app-version-info';
import { getDeviceId } from 'utils/device-id';
import { getCurrentCommitHash } from 'utils/environment';

import { EnvItem } from '../components/env-item';

export function PublicDiagnostics() {
  const buildMetadata = getBuildMetadata();

  return (
    <>
      <Divider />
      <Header pt={4} variant="headerFour">
        Device Information
      </Header>
      <EnvItem envKey="Device Id" value={getDeviceId()} />

      <Divider />

      <Header pt={4} variant="headerFour">
        Update OTA Build Info
      </Header>
      <EnvItem envKey="OTA App Version" value={appVersion} />
      <EnvItem envKey="Commit Hash" value={getCurrentCommitHash()} />
      <EnvItem envKey="Build Date" value={Updates.createdAt?.toLocaleString()} />
      <EnvItem envKey="Update Id" value={Updates.updateId} />
      <EnvItem envKey="Update Channel" value={Updates.channel} />
      <EnvItem envKey="Is Embedded Launch?" value={Updates.isEmbeddedLaunch + ''} />

      <Header pt={4} variant="headerFour">
        Binary runtime info
      </Header>
      <EnvItem envKey="App Version" value={binaryRuntimeAppVersionWithBuildNumber} />
      <EnvItem envKey="Build metadata source" value={buildMetadata.source} />
      <EnvItem envKey="EAS build id" value={buildMetadata.easBuildId} />
      <EnvItem envKey="EAS build profile" value={buildMetadata.easBuildProfile} />
      <EnvItem envKey="EAS build platform" value={buildMetadata.easBuildPlatform} />
      <EnvItem envKey="EAS app version" value={buildMetadata.easAppVersion} />
      <EnvItem envKey="EAS app build version" value={buildMetadata.easAppBuildVersion} />
      <EnvItem envKey="Build git commit hash" value={buildMetadata.gitCommitHash} />
    </>
  );
}
